<template>
  <page-wrapper ref="pageEl" :title="title">
    <div class="header">
      <div class="row">
        <div class="col-3 max">
          <div>วันที่ปิดงาน</div>
          <date-picker
            v-model="fulfilledDateRange"
            type="daterange"
          ></date-picker>
        </div>
        <div class="col-2 max">
          <div>เลือกสถานะ Rating</div>
          <el-select v-model="query.ratingType" clearable>
            <el-option
              v-for="t in filterRatingType"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-3 max">
          <div>เลือกสถานะการมอบหมายงาน</div>
          <el-select v-model="query.assignment" clearable>
            <el-option
              v-for="t in filterAssignmentType"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-4 max">
          <div>{{ adminRowTitle }}</div>
          <admin-by-row-selector
            v-model="query.adminId"
            :role="adminRoleCC"
            :disabled="!canAdminFilter"
            :placeholder="'กรุณาเลือก สถานะการมอบหมายงานแล้ว'"
          ></admin-by-row-selector>
        </div>
        <div class="col-2 max">
          <div>สถานะ</div>
          <el-select v-model="query.contactStatus" clearable>
            <el-option
              v-for="t in filterRatingContactStatus"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-3 max">
          <div>บ้านเลขที่</div>
          <el-input v-model="query.houseNumber" type="text"></el-input>
        </div>
        <div class="col-4 max">
          <div>ชื่อ/นามสกุล ลูกบ้าน</div>
          <el-input v-model="query.name" type="text"></el-input>
        </div>
        <div class="col-3 max">
          <div>เบอร์โทร</div>
          <el-input v-model="query.phoneNumber" type="text"></el-input>
        </div>
       
      </div>
      <div class="row">
        <div class="col-3 max">
          <div>ซ่อน service</div>
          <el-input v-model="query.filterServiceId" type="text"></el-input>
        </div>
        <div class="col-3 max">
          <div>ค้นหา service</div>
          <el-input v-model="query.serviceTextSearch" type="text"></el-input>
        </div>
      </div>
      <div class="text-end">
        <sc-button variant="primary" @click="handleClickSearch"
          >ค้นหา</sc-button
        >
      </div>
    </div>
    <div class="mt-4 padding-left">
      <sc-button variant="secondary" @click="handleClickDownloadReport"
        >Download Report</sc-button
      >
      <sc-button
        variant="secondary"
        class="mb-3"
        @click="handleClickDownloadTermiteControlServiceReport"
        >Download Termite Control Service Report</sc-button
      >
      <p v-if="total">{{ totalCount }}</p>
    </div>
    <div v-if="isCanAssignByRoles" class="padding-left outer">
      <div class="inner">
        <admin-by-row-selector
          v-model="adminIdForContactAssignment"
          :role="adminRoleCC"
          :disabled="isSelecting"
          :text-for-disable-admin="textForDisableAdmin"
        ></admin-by-row-selector>
      </div>
      <div class="inner">
        <sc-button
          variant="primary"
          @click="handleClickSaveAdminForContactAssignment"
          >บันทึก</sc-button
        >
      </div>
      <div class="inner ms-3">{{ countByAssignAdminRatting }}</div>
    </div>
    <div class="mt-2">
      <div v-if="noResult" class="p-4 text-center">ไม่มีข้อมูล</div>
      <div v-else>
        <div class="row-header">
          <div class="cell center small">เลือก Agent</div>
          <div class="cell">admin ที่ได้รับมอบหมาย</div>
          <div class="cell center">รหัสโครงการ</div>
          <div class="cell">บ้านเลขที่</div>
          <div class="cell">ชื่อลูกค้า</div>
          <div class="cell">นามสกุล</div>
          <div class="cell">หมายเลขโทรศัพท์</div>
          <div class="cell">ชื่อบริการ</div>
          <div class="cell center">UUID</div>
          <div class="cell center">ครั้งที่</div>
          <div class="cell center">เลขที่ใบงานแจ้งซ่อม</div>
          <div class="cell center">rate</div>
          <div class="cell">comment</div>
          <div class="cell">commentAdmin</div>
          <div class="cell">status</div>
          <div class="cell">วันเวลาที่ใช้บริการ</div>
          <div class="cell">วันปิดงาน</div>
          <div class="cell">วันเวลาที่ให้ rating</div>
          <div class="cell">ลูกค้าบันทึกคะแนน</div>
          <div class="cell">adminบันทึก</div>
        </div>
        <div>
          <div
            v-for="item in list"
            :key="item.id"
            v-bind="item"
            class="row-detail"
          >
            <div class="cell center">
              <input
                v-model="item.isAssignRating"
                v-validate="'required'"
                :disabled="
                  (
                    isViewOnlyByRole
                    && (item.adminAssignedContactId !== adminIdForContactAssignment)
                  ) || !adminIdForContactAssignment
                "
                type="checkbox"
                name="userRole"
                class="cell checkbox"
                @change="
                  handleAssignRating(item.appointmentId, item.isAssignRating)
                "
              />
            </div>
            <div class="cell">{{ item.adminAssignedContactName }}</div>
            <div class="cell center">{{ item.projectCode }}</div>
            <div class="cell">{{ item.addressNo }}</div>
            <div class="cell">{{ item.firstName }}</div>
            <div class="cell">{{ item.lastName }}</div>
            <div class="cell">{{ item.mobileNumber }}</div>
            <div class="cell">
              <div  v-if="!isViewOnlyByRole">
                <router-link
                  :to="item.routeAppointmentDetail"
                  class="underline"
                  >{{ item.serviceName }}
                </router-link>
                &nbsp;&nbsp;
                <sc-button
                  variant="secondary"
                  class="sm"
                  @click="handleClickHideService(item.serviceId)"
                  >ซ่อนบริการนี้</sc-button
                >
              </div>
              <div  v-if="isViewOnlyByRole">{{ item.serviceName }}</div>

            </div>
            <div class="cell center">{{ item.appointmentId }}</div>
            <div class="cell center">{{ item.appointmentNo }}</div>
            <div class="cell center">{{ item.maintainRequestNo }}</div>
            <div class="cell center">
              <rating-confirm-box-selector
                :value="item"
                @reload="setupNewFormRating"
              ></rating-confirm-box-selector>
            </div>
            <div class="cell">{{ item.comment }}</div>
            <div class="cell">{{ item.commentAdmin }}</div>
            <div class="cell">{{ item.contactStatusTh }}</div>
            <div class="cell">{{ item.appointmentAt }}</div>
            <div class="cell">{{ item.appointmentFulfilledAt }}</div>
            <div class="cell">{{ item.submittedRatingFormAt }}</div>
            <div class="cell">{{ item.customerRate }}</div>
            <div class="cell">{{ item.adminTakeAction }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper page">
      <el-pagination
        :total="total"
        :current-page="query.page"
        :page-size="30"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { getDownloadedReport } from "@/god";
import { Pagination, Select, Option, Input } from "element-ui";
import DatePicker from "@/lib/components/DatePicker";
import { DateTime } from "luxon";
import AdminByRowSelector from "@/lib/components/AdminByRowSelector";
import { permissionRole , filterRatingContactStatus } from "@/lib/mapper";
import { existValueAndEmptyString, existValue } from "@/lib/util";
import RatingConfirmBoxSelector from "../components/RatingConfirmBoxSelector";
import { getAdminRolePermission } from "../adminRolePermission";

function sanitizeListPage(value) {
  const page = parseInt(value, 10);

  if (Number.isNaN(page) || page < 1) {
    return 1;
  }

  return page;
}

function trimQueryValue(value) {
  if (value == null) {
    return "";
  }

  return String(value).trim();
}

export default {
  name: "RatingListPage",
  components: {
    "page-wrapper": PageWrapper,
    "sc-button": ScButton,
    "el-pagination": Pagination,
    "date-picker": DatePicker,
    "el-select": Select,
    "el-option": Option,
    "el-input": Input,
    "admin-by-row-selector": AdminByRowSelector,
    "rating-confirm-box-selector": RatingConfirmBoxSelector
  },
  data() {
    const title = "Rating";
    const assigned = "ASSIGNED";
    const query = {
      page: 1,
      ratingType: "",
      ratingFulfilledToDate: null,
      ratingFulfilledFromDate: null,
      adminId: null,
      assignment: null,
      houseNumber: null,
      name: null,
      phoneNumber: null,
      contactStatus: null,
      filterServiceId: null,
      serviceTextSearch: null
    };

    const filterRatingType = [
      { label: "ทั้งหมด", value: "" },
      { label: "ให้คะแนนแล้ว", value: "RATED" },
      { label: "ยังไม่ให้คะแนน", value: "NOT_RATED" }
    ];

    const filterAssignmentType = [
      { label: "ทั้งหมด", value: "" },
      { label: "มอบหมายงานแล้ว", value: assigned },
      { label: "ยังไม่มอบหมายงาน", value: "NOT_ASSIGN" }
    ];

    const permission = getAdminRolePermission();

    return {
      title,
      list: [],
      total: 0,
      query,
      fulfilledDateRange: [],
      filterRatingType,
      oldQuery: null,
      adminRoleCC: permissionRole.CC,
      adminIdForContactAssignment: null,
      filterAssignmentType,
      assigned,
      permission,
      filterRatingContactStatus,
      countAppointmentRatingForAssignedAdmin: 0,
      isSelecting: false
    };
  },
  computed: {
    noResult() {
      return this.list.length === 0;
    },
    ratingPresenter() {
      if (!this.list || this.list.length === 0) return [];

      return this.list;
    },
    totalCount() {
      const limit = 30;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.list.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.query.page;
      const end = isLastPage ? total : currentPage * limit;
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    adminRowTitle() {
      return `Agent (${this.adminRoleCC})`;
    },
    canAdminFilter() {
      return (
        existValueAndEmptyString(this.query.assignment) &&
        this.query.assignment === this.assigned
      );
    },
    isCanAssignByRoles() {
      const roles = ["CC", "ADMIN"];

      return this.permission && roles.includes(this.permission.role);
    },
    countByAssignAdminRatting() {
      return !this.isViewOnlyByRole
        ? `จำนวน Assign : ${this.countAppointmentRatingForAssignedAdmin + this.countAssignChanging} Case`
        : "";
    },
    countAssignChanging() {
      const countForNewAssign = this.list.filter(
        (t) => !t.adminAssignedContactId && t.isAssignRating === true
      ).length

      const countForRemoveAssigned = this.list.filter(
        (t) => t.adminAssignedContactId && t.isAssignRating === false
      ).length

      return countForNewAssign - countForRemoveAssigned
    },
    textForDisableAdmin() {
      return this.isSelecting === true
        ? 'กด "บันทึก" เพื่อยืนยันข้อมูล'
        : null;
    },
    isViewOnlyByRole() {
      const roles = ["MK", "CRM", "HC", "JU", "FI", "AC", "REA", "CS", "HOS", "HOA", "LMA", "LMC", "LMM", "WSADMIN", "CDS"];

      return !!(this.permission && roles.includes(this.permission.role));
    },
  },
  watch: {
    "$route.query": async function watchRouteQuery() {
      this.setupQuery();
      await this.setupData();

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0;
    },
    async adminIdForContactAssignment(newAdminId) {
      await this.getCountAppointmentRatingForAssignedAdmin(
        newAdminId
      );
    }
  },
  created() {
    this.setupQuery();
    this.setupData();
  },
  methods: {
    setupQuery() {
      this.query = {
        page: sanitizeListPage(this.$route.query.page),
        ratingFulfilledToDate: this.$route.query.ratingFulfilledToDate || null,
        ratingFulfilledFromDate:
          this.$route.query.ratingFulfilledFromDate || null,
        ratingType: this.$route.query.ratingType || "",
        adminId: this.$route.query.adminId || null,
        assignment: this.$route.query.assignment,
        houseNumber: trimQueryValue(this.$route.query.houseNumber),
        name: trimQueryValue(this.$route.query.name),
        phoneNumber: trimQueryValue(this.$route.query.phoneNumber),
        contactStatus: this.$route.query.contactStatus || "",
        filterServiceId: this.$route.query.filterServiceId || "",
        serviceTextSearch: trimQueryValue(this.$route.query.serviceTextSearch),
      };

      if (
        this.$route.query.ratingFulfilledToDate &&
        this.$route.query.ratingFulfilledFromDate
      ) {
        this.fulfilledDateRange = [
          DateTime.fromISO(this.$route.query.ratingFulfilledToDate),
          DateTime.fromISO(this.$route.query.ratingFulfilledFromDate)
        ];
      }

      const {query} = this;

      if (
        !existValue(query.ratingFulfilledToDate) &&
        !existValue(query.ratingFulfilledFromDate) &&
        !existValue(query.ratingType) &&
        !existValue(query.adminId) &&
        !existValue(query.assignment) &&
        !existValue(query.houseNumber) &&
        !existValue(query.name) &&
        !existValue(query.phoneNumber) &&
        !existValue(query.contactStatus) &&
        !existValue(query.filterServiceId) &&
        !existValue(query.serviceTextSearch) &&
        this.permission.role === permissionRole.CC
      ) {
        this.query.adminId = +localStorage.adminId;
        this.query.assignment = this.assigned;

        this.$router.push({
          name: "RatingListPage",
          query: {
            adminId: +localStorage.adminId,
            assignment: this.assigned
          }
        });
      }
    },
    async setupData() {
      const ratingList = await this.fetchRatings();

      if (this.query && this.query.adminId) {
        this.adminIdForContactAssignment = this.query.adminId;
      }

      this.total = ratingList.count;

      this.list = ratingList.rows.map((rating) => ({
          appointmentId: rating.appointment_id,
          projectName: rating.project_name,
          projectCode: rating.project_code,
          addressNo: rating.address_no,
          firstName: rating.first_name,
          lastName: rating.last_name,
          citizenId: rating.citizen_id,
          mobileNumber: rating.mobile_number,
          packageName: rating.package_name,
          serviceName: rating.service_name,
          providerName: rating.provider_name,
          topic: rating.topic,
          question: rating.question,
          rate: rating.rate,
          comment: rating.comment,
          commentAdmin: rating.comment_admin,
          appointmentAt: rating.appointment_at,
          appointmentFulfilledAt: rating.appointment_fulfilled_at,
          submittedRatingFormAt: rating.submitted_rating_form_at,
          serviceId: rating.service_id,
          homeId: rating.home_id,
          subscriptionId: rating.subscription_id,
          userId: rating.user_id,
          adminName: rating.admin_name,
          adminAssignedContactName: rating.admin_assigned_contact_name,
          isAssignRating: !!rating.admin_assigned_contact_name,
          contactStatus: rating.contact_status,
          ratingFormSubmissionId: rating.rating_form_submission_id,
          ratingQuestionSubmissionsId: rating.rating_question_submissions_id,
          contactStatusTh: rating.contact_status_th,
          routeAppointmentDetail: {
            name: "AppointmentDetailPage",
            params: { id: rating.appointment_id }
          },
          adminAssignedContactId: rating.admin_assigned_contact_id,
          adminTakeAction: rating.admin_name,
          customerRate: rating.customer_rating,
          maintainRequestNo: rating.maintain_request,
          appointmentNo: rating.appointment_no
        }));
    },
    async fetchRatings() {
      try {
        const response =
          await baanRueJaiClient.admin.subscriptions.ratings.getReport({
            ...this.query,
            format: "data"
          });

        return response.data.result;
      } catch (error) {
        this.$message.error(
          "ไม่สามารถแสดง Report ได้ เนื่องจากไม่มีข้อมูลหรือเกิดข้อผิดพลาด"
        );
        return undefined;
      }
    },
    async handleClickDownloadReport() {
      try {
        const response =
          await baanRueJaiClient.admin.subscriptions.ratings.getReport({
            ...this.query,
            format: "xlsx"
          });

        getDownloadedReport(response.data, `report-ratings.xlsx`);
      } catch (error) {
        this.$message.error(
          "ไม่สามารถ Download Report ได้ เนื่องจากไม่มีข้อมูลหรือเกิดข้อผิดพลาด"
        );
      }
    },
    async handleClickDownloadTermiteControlServiceReport() {
      try {
        const response =
          await baanRueJaiClient.admin.subscriptions.ratings.getTermiteControlServiceReport();

        getDownloadedReport(
          response.data,
          `report-termite-control-service.xlsx`
        );
      } catch (error) {
        this.$message.error(
          "ไม่สามารถ Dowload Report ได้ เนื่องจากไม่มีข้อมูลหรือเกิดข้อผิดพลาด"
        );
      }
    },
    handleCurrentChange(page) {
      this.query.page = parseInt(page, 10);
      this.oldQuery = this.query;

      const route = {
        ...this.$route,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    },
    handleClickSearch() {
      if (
        this.fulfilledDateRange &&
        this.fulfilledDateRange[0] &&
        this.fulfilledDateRange[1]
      ) {
        this.query.ratingFulfilledToDate = this.fulfilledDateRange[0].toISO();
        this.query.ratingFulfilledFromDate = this.fulfilledDateRange[1].toISO();
      } else {
        this.query.ratingFulfilledToDate = null;
        this.query.ratingFulfilledFromDate = null;
      }

      if (
        !this.oldQuery ||
        !this.oldQuery.ratingType ||
        this.oldQuery.ratingType !== this.query.ratingType
      ) {
        this.query.page = 1;
      }

      if (!this.canAdminFilter) {
        this.query.adminId = null;
      }

      const route = {
        ...this.$route,
        query: this.query
      };

      this.oldQuery = this.query;
      this.$router.replace(route);
    },
    async handleClickHideService(serviceId) {
      if (this.query.filterServiceId.length === 0) {
        this.query.filterServiceId = serviceId
      } else {
        this.query.filterServiceId += `,${serviceId}`
      }
      this.handleClickSearch()
    },
    async setupNewFormRating() {
      this.setupQuery();
      await this.setupData();
    },
    async handleClickSaveAdminForContactAssignment() {
      if (!this.adminIdForContactAssignment) {
        this.$message.error("กรุณาเลือก admin(CC) ก่อนบันทึก");
        return;
      }

      await this.saveAdminAssignAppointToContact();
    },
    async saveAdminAssignAppointToContact() {
      if (!this.list || this.list.length === 0) {
        this.$message.error('ไม่มีข้อมูลนัดหมายให้บันทึก assign');
        return
      }

      const appointmentForUpdateAssignRating = this.list.map((appoint) => {
        let {adminAssignedContactId} = appoint;
        if (
          appoint.isAssignRating === true &&
          !appoint.adminAssignedContactId &&
          this.adminIdForContactAssignment
        ) {
          adminAssignedContactId = this.adminIdForContactAssignment;
        } else if (
          appoint.adminAssignedContactId &&
          appoint.isAssignRating === false
        ) {
          adminAssignedContactId = null;
        }

        return {
          appointment_id: appoint.appointmentId,
          admin_id_for_contact: adminAssignedContactId,
        };
      });

      const params = {
        appointment_for_update_assign_rating: appointmentForUpdateAssignRating
      }

      try {
        await baanRueJaiClient.admin.subscriptions.ratings.updateAdminAssignAppointmentToContact(
          this.adminIdForContactAssignment,
          params
        );

        this.$message.success("มอบหมายงานให้ agent เรียบร้อย");
        await this.setupData();

        if (!this.query.adminId) this.adminIdForContactAssignment = null;

        if (this.adminIdForContactAssignment) {
          await this.getCountAppointmentRatingForAssignedAdmin(
            this.adminIdForContactAssignment
          );
        }
      } catch (err) {
        this.$message.error("ไม่สามารถมอบหมายงานให้ agent ได้");
      }

      this.isSelecting = false;
    },
    handleAssignRating(appointmentId, isAssignRating) {
      this.list = this.list.map((appoint) => ({
          ...appoint,
          isAssignRating:
            appointmentId === appoint.appointmentId
              ? isAssignRating
              : appoint.isAssignRating,
        }));

      this.isSelecting = true;
    },
    async getCountAppointmentRatingForAssignedAdmin(adminId) {
      if (!this.adminIdForContactAssignment || !adminId) {
        this.countAppointmentRatingForAssignedAdmin = 0;
        return;
      }

      try {
        const response =
          await baanRueJaiClient.admin.subscriptions.appointments.getCountAppointmentRatingForAssignedAdmin(
            adminId
          );

        this.countAppointmentRatingForAssignedAdmin =
          response.data.message || 0;
      } catch (error) {
        this.$message.error("ไม่สามารถค้นหาจำนวน assign ได้");
        this.countAppointmentRatingForAssignedAdmin = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: 30px;
}

.row-header {
  display: grid;
  grid-template-columns:
    100px
    220px
    150px
    120px
    220px
    220px
    180px
    400px
    220px
    120px
    220px
    120px
    300px
    300px
    150px
    150px
    150px
    150px
    250px
    250px
    250px;

  // padding: ($space / 2) $space;
  font-weight: bold;
  position: sticky;
  top: 0;
  padding-left: 20px;
  z-index: 1;

  .cell {
    border-top: 1px solid #444;
    font-weight: bold;
    background: #ddd;
    height: 50px;
    padding-top: 10px;
    padding-left: 20px;
    overflow: auto;
  }

  > .center {
    text-align: center;
  }

  > .small {
    font-size: 15px;
  }
}

.row-detail {
  display: grid;
  grid-template-columns:
    100px
    220px
    150px
    120px
    220px
    220px
    180px
    400px
    220px
    120px
    220px
    120px
    300px
    300px
    150px
    150px
    150px
    150px
    250px
    250px
    250px;

  font-weight: normal;
  padding-left: 20px;
  padding-top: 10px;
  height: inherit;

  > .center {
    text-align: center;
  }

  .cell {
    padding-top: 5px;
    padding-left: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgb(209, 208, 208);
    overflow: auto;
  }
}

.page {
  padding-top: 15px;
  text-align: right;
}

.space {
  padding-left: 0.8em;
}

.padding-left {
  padding-left: 20px;
}

.select-rating {
  text-align: left;
}

.checkbox {
  transform: scale(2);
}

.outer {
  width: 100%;
}

.inner {
  display: inline-block;
}

.el-range-editor.el-input__inner,
.el-select,
el-option {
  width: 100%;
}

.max {
  padding-left: 0;
  padding-right: 15px;
  margin-bottom: 15px;
}

.underline {
  text-decoration: underline;
}
</style>
